module.exports = __webpack_public_path__ + "img/bg08.6bee9bfc.gif";